import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertTitle } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import { getItemFromLocalStorage } from 'lib/helper';
import React from 'react';
import ReactQuill from 'react-quill';
import Select from 'react-select';

// reactstrap components
import { MagicSpinner } from 'react-spinners-kit';
import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  FormGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';

import history from '../../../history';
import axios from '../../../lib/axiosInstance';

import '@y0c/react-datepicker/assets/styles/calendar.scss';
import { verifyAccessToken } from '../../../lib/auth';

import 'react-quill/dist/quill.snow.css';
import NoRecordFound from '../../../components/NoRecordFound/NoRecordFound';
import CustomModalWrapper from '../../../components/CustomModalWrapper/CustomModalWrapper';

const QModules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote', 'code-block'],

    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    // [{ 'direction': 'rtl' }],                         // text direction

    ['link', 'image'],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme

    // [{ 'align': [] }],

    ['clean'],
  ],
};

const QFormats = [
  'header',
  'color',
  'font',
  'code',
  'size',
  'script',
  'align',
  'direction',
  'code-block',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
];

// import calendar style
const colourStyles = {
  control: (styles) => ({
    ...styles,
    // backgroundColor: 'white'
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
    };
  },
};
const memberStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: 'transparent',
    marginLeft: 'auto',
    theme: 'primary',
    marginRight: 'auto',
    border: '1px solid #CCCCCC',
    borderRadius: '50%',
    padding: '0px',
    width: '40px',
    height: '40px',
  }),
  container: (styles) => ({
    ...styles,
    border: '0px solid #FFFFFF',
    padding: '3px',
  }),
  input: (styles) => ({ ...styles, border: '0px solid #FFFFFF' }),
  indicatorsContainer: (styles) => ({
    ...styles,
    border: '0px solid #FFFFFF',
    display: 'none',
  }),
  placeholder: (styles) => ({
    ...styles,
    border: '0px solid #FFFFFF',
    backgroundColor: 'transparent',
  }),
  valueContainer: (styles) => ({ ...styles, border: '0px solid #FFFFFF' }),
  menuList: (styles) => ({ ...styles, minWidth: '150px' }),
  menu: (styles) => ({ ...styles, minWidth: '150px' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
    };
  },
};
const slimColourStyles = {
  // menu: (provided, state) => ({
  //     ...provided,
  //     width: state.selectProps.width,
  //     // borderBottom: '1px dotted pink',
  //     // color: state.selectProps.menuColor,
  //     // padding: 20,
  // }),
  control: (styles) => ({
    ...styles,
    // backgroundColor: 'white',
    paddint: '5px',
    maxHeight: '50px',
    // maxWidth: '100px',
    marginLeft: 'auto',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
    };
  },
};
const SeverityList = {
  5: 'Critical',
  4: 'Urgent',
  3: 'Serious',
  2: 'Medium',
  1: 'Minimal',
};
const SourceTypeList = {
  was_data: 'Web Apps',
  endpoint_data: 'Endpoints',
  'ca_data-all': 'Cloud Agents - All',
  ca_data: 'Cloud Agents - Servers',
  'ca_data-workstations': 'Cloud Agents - Workstations',
};
const TypeList = {
  open: 'Active - All',
  active: 'Existing',
  fixed: 'Fixed',
  new: 'New',
  reopened: 'Reopened',
};

const PAGE_SIZES = [
  { value: '25', label: '25' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
  { value: '200', label: '200' },
];

class ReleaseNoteList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      modal: false,
      notesmodal: false,
      notes: [],
      watcher_modal: false,
      watchers: [],
      currentReport: {},
      companies: [],
      currentData: {},
      tagData: [],
      hostapps: [{ value: '', label: 'All' }],
      current_host: { value: '', label: 'All' },
      searchValue: '',
      source_type: { value: 'was_data', label: 'Web Apps' }, //{ value: "", label: "All" },
      currentTag: {},
      selectedTags: [],
      company_search_data: '',
      openModal: false,
      loader: true,
      currentPage: 0,
      pageSize: 25.0,
      ordering: '-id',
      issue_type: 'VULNERABILITY',
      active_or_fixed: { value: 'open', label: 'Active - All' },
      selectedSeverityOption: { value: '', label: 'All' },
      selectedCategoryOption: { value: '', label: 'All' },
      webapp: '',
      endpoint: '',
      current_note: '',
      members: [],
      editorValue: '',
    };
  }

  approle = getItemFromLocalStorage('approle') || 'guest';

  orderBy(target) {
    let field = target;
    if (this.state.ordering === field) {
      field = '-' + field;
    }
    this.setState({ ordering: field });
    let self = this;
    setTimeout(function () {
      self.fetchFindings();
    }, 60);
  }

  renderLoader() {
    if (this.state.loader === true) {
      return (
        <section className="loader-section">
          <MagicSpinner size={60} color="#0665a9" loading={this.state.loader} />
        </section>
      );
    }
  }
  toggle() {
    let modal = this.state.modal;
    this.setState({ modal: !modal });
  }
  toggleNotesModal() {
    this.setState({ notesmodal: !this.state.notesmodal });
  }
  componentDidMount() {
    let patchable = window.location.search.split('patchable=');
    if (patchable.length > 1) {
      patchable = window.location.search.split('patchable=')[1].split('&')[0];
      this.setState({
        selectedCategoryOption: {
          value: '&knowledge_base__patchable=1',
          label: 'Patchable',
        },
      });
    }
    let webapp = window.location.search.split('webapp=');
    if (webapp.length > 1) {
      webapp = webapp[1].split('&')[0];
      this.setState({ webapp: webapp });
    }
    let endpoint = window.location.search.split('endpoint=');
    if (endpoint.length > 1) {
      endpoint = endpoint[1].split('&')[0];
      this.setState({ endpoint: endpoint });
    }
    let cloudagent_id = window.location.search.split('cloudagent_id=');
    if (cloudagent_id.length > 1) {
      cloudagent_id = cloudagent_id[1].split('&')[0];
      this.setState({ cloudagent_id: cloudagent_id });
    }
    let search = window.location.search.split('search=');
    if (search.length > 1) {
      search = window.location.search.split('search=')[1].split('&')[0];
      this.setState({ company_search_data: search });
    }
    let filter_severity = window.location.search.split('filter_severity=');
    if (filter_severity.length > 1) {
      filter_severity = window.location.search
        .split('filter_severity=')[1]
        .split('&')[0];
      this.setState({ filter_severity: filter_severity });
    } else if (window.location.search.split('severity=').length > 1) {
      let severity = window.location.search.split('severity=')[1].split('&')[0];

      let selectedSeverityOption = {
        value: severity,
        label: SeverityList[severity],
      };
      this.setState({ selectedSeverityOption: selectedSeverityOption });
    }
    if (window.location.search.split('source_type=').length > 1) {
      let source_type = window.location.search
        .split('source_type=')[1]
        .split('&')[0];

      source_type = { value: source_type, label: SourceTypeList[source_type] };
      this.setState({ source_type: source_type });
    }
    let type = window.location.search
      .replace('source_type=', 'dummy=')
      .split('type=');
    if (type.length > 1) {
      type = type[1].split('&')[0];
      let active_or_fixed = { value: type, label: TypeList[type] };
      this.setState({ active_or_fixed: active_or_fixed });
    }
    this.fetchFindings.bind(this)();
    localStorage.setItem('last_path', window.location.pathname);
    localStorage.setItem('releaseNoteLastVisitedDate', Date.now());
  }

  async fetchFindings(currentUrl, currentPage, company_id, reauth) {
    this.setState({ loader: true });
    await verifyAccessToken();
    if (company_id === undefined) {
      company_id = this.props.currentCompanyId;
    }
    let url =
        '/release_notes/?search=' +
        this.state.company_search_data +
        '&limit=' +
        parseInt(this.state.pageSize),
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };

    if (currentUrl) {
      url = currentUrl;
    }

    url += '&ordering=' + this.state.ordering;
    if (currentPage !== undefined) {
      this.setState({ currentPage: currentPage });
    } else {
      this.setState({ currentPage: 0 });
    }
    url += '&company=' + this.props.currentCompanyId;

    if (this.state.filter_severity && this.state.filter_severity !== '') {
      url += '&severity__in=5,4';
    } else {
      url += '&severity=' + this.state.selectedSeverityOption.value;
    }
    if (this.state.patchable && this.state.patchable !== '') {
      url += '&knowledge_base__patchable=1';
    }
    url += this.state.selectedCategoryOption.value;
    let status = this.state.active_or_fixed.value.toUpperCase();
    if (status === 'OPEN') {
      url += '&open_status=1';
    } else {
      url += '&status=' + status;
    }
    // }
    if (this.state.source_type.value !== '') {
      url += '&source_type=' + this.state.source_type.value;
    } else {
      url += '&source_type=';
    }
    if (this.state.issue_type !== '')
      url += '&issue_type=' + this.state.issue_type;
    if (this.state.source_type.value === 'was_data') {
      if (this.state.current_host.value) {
        // console.log('WebApp Host', this.state.current_host.value)
        url += '&webapp=' + this.state.current_host.value;
      } else if (this.state.webapp) {
        // console.log('WebApp', this.state.webapp)
        url += '&webapp=' + this.state.webapp;
      }
    } else if (
      this.state.source_type.value === 'ca_data' ||
      this.state.source_type.value === 'ca_data-workstations'
    ) {
      if (this.state.current_host.value)
        url += `&cloud_agent=${this.state.current_host.id}`;
    } else if (this.state.source_type.value === 'endpoint_data') {
      if (this.state.current_host.value)
        url += `&endpoint=${this.state.current_host.id}`;
    } else if (this.state.source_type.value === 'was_data') {
      url += '&webapp=' + this.state.webapp;
    }
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data.results) {
            this.setState({
              loader: false,
              reports: res.data.results,
              count: res.data.count,
              nextUrl: res.data.next
                ? '/release_notes/?' + res.data.next.split('?')[1]
                : null,
              previousUrl: res.data.previous
                ? '/release_notes/?' + res.data.previous.split('?')[1]
                : null,
            });
            if (document.getElementsByClassName('main-panel').length > 0)
              document.getElementsByClassName('main-panel')[0].scrollTop = 0;
          } else {
            this.setState({ reports: [], count: 0 });
          }

          this.setState({ modal: false });
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
          if (reauth === true) {
            localStorage.removeItem('refresh');
            localStorage.removeItem('access');
            localStorage.removeItem('refreshTokenSetAt');
            localStorage.removeItem('accessTokenSetAt');
            history.push('/login');
          } else this.fetchFindings(currentUrl, currentPage, company_id, true);
        }
      }); //.catch(err => {
    //     if (reauth === true) {

    //         history.push('/login')
    //     } else {
    //         if (err.response.status === 401) this.fetchFindings(currentUrl, currentPage, company_id, true)
    //         this.setState({ loader: false })
    //         console.log(err)
    //     }
    // });
  }

  async fetchFindingNotes(id) {
    this.setState({ loader: true });
    if (id === undefined || id === '') {
      this.setState({
        current_note: {},
        loader: false,
        notesmodal: true,
      });
    } else {
      await verifyAccessToken();
      let url = '/release_notes/' + id + '/',
        headers = {
          Authorization: 'Bearer ' + localStorage.getItem('access'),
        };
      await axios
        .get(url, {
          headers: headers,
        })
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            if (res.data) {
              this.setState({
                current_note: res.data,
                loader: false,
                notesmodal: true,
                editorValue: res.data.description,
              });
            }
          } else if (res.status === 422) {
          } else if (res.status === 401 || res.status === 400) {
          }
        });
    }
  }
  async saveNote() {
    this.setState({ loader: true });
    await verifyAccessToken();
    let data = {
      title: this.state.current_note.title,
      version: this.state.current_note.version,
      description: this.state.editorValue,
    };
    if (
      this.state.current_note.id === '' ||
      this.state.current_note.id === undefined
    ) {
      let url = '/release_notes/',
        headers = {
          Authorization: 'Bearer ' + localStorage.getItem('access'),
        };
      await axios
        .post(url, data, {
          headers: headers,
        })
        .then((res) => {
          //console.log('Fetched Data',res.data)
          if (res.status === 201 || res.status === 200) {
            if (res.data) {
              this.setState({
                loader: false,
                notesmodal: true,
                openModal: true,
                is_success: true,
                modalTitle: 'Release Note added',
                modalDetail: 'Your note has been successfully posted.',
                editorValue: '',
              });

              this.setState({
                loader: false,
                notesmodal: false,
                openModal: false,
              });
            }
            let self = this;
            setTimeout(function () {
              self.fetchFindings(
                undefined,
                undefined,
                self.props.currentCompanyId,
              );
            }, 60);
          } else if (res.status === 422) {
          } else if (res.status === 401 || res.status === 400) {
          }
        });
    } else {
      let url = '/release_notes/' + this.state.current_note.id + '/',
        headers = {
          Authorization: 'Bearer ' + localStorage.getItem('access'),
        };
      await axios
        .patch(url, data, {
          headers: headers,
        })
        .then((res) => {
          //console.log('Fetched Data',res.data)
          if (res.status === 201 || res.status === 200) {
            if (res.data) {
              this.setState({
                loader: false,
                notesmodal: true,
              });
              this.setState({
                openModal: true,
                is_success: true,
                modalTitle: 'Note updated',
                modalDetail: 'Your note has been successfully posted.',
                editorValue: '',
              });
              this.setState({
                loader: false,
                notesmodal: false,
                openModal: false,
              });
            }

            let self = this;
            setTimeout(function () {
              self.fetchFindings(
                undefined,
                undefined,
                self.props.currentCompanyId,
              );
            }, 60);
          } else if (res.status === 422) {
          } else if (res.status === 401 || res.status === 400) {
          }
        });
    }
  }
  renderNextUrl() {
    if (this.state.nextUrl !== null) {
      return (
        <PaginationItem>
          <PaginationLink
            next
            onClick={() =>
              this.fetchFindings(this.state.nextUrl, this.state.currentPage + 1)
            }
          />
        </PaginationItem>
      );
    } else {
      return <></>;
    }
  }
  renderPreviousUrl() {
    if (this.state.previousUrl !== null) {
      return (
        <PaginationItem>
          <PaginationLink
            previous
            onClick={() =>
              this.fetchFindings(
                this.state.previousUrl,
                this.state.currentPage - 1,
              )
            }
          />
        </PaginationItem>
      );
    } else {
      return <></>;
    }
  }
  renderPages() {
    let pages = [];
    let pageCount = Math.ceil(this.state.count / this.state.pageSize),
      currentPage = this.state.currentPage;
    let leftPages = pageCount > 10 ? (currentPage > 8 ? 6 : 10) : pageCount;
    let midPages = currentPage > 8 ? 3 : 0;
    let rightPages = pageCount - leftPages;
    for (let index = 0; index < leftPages; index++) {
      let url =
        '/release_notes/?search=' +
        this.state.company_search_data +
        '&limit=' +
        parseInt(this.state.pageSize) +
        '&offset=' +
        parseInt(this.state.pageSize * index);
      pages.push(
        <PaginationItem
          key={index}
          className={this.state.currentPage === index ? 'active' : ''}
        >
          <PaginationLink onClick={() => this.fetchFindings(url, index)}>
            {index + 1}
          </PaginationLink>
        </PaginationItem>,
      );
    }
    if (midPages > 1) {
      pages.push(<PaginationItem className="more-pages">...</PaginationItem>);
    }
    for (let index = 0; index < midPages; index++) {
      let pageIndex = index - 1 + currentPage;
      if (pageIndex < pageCount - 1) {
        let url =
          '/release_notes/?search=' +
          this.state.company_search_data +
          '&limit=' +
          this.state.pageSize +
          '&offset=' +
          parseInt(this.state.pageSize * pageIndex);
        pages.push(
          <PaginationItem
            className={this.state.currentPage === pageIndex ? 'active' : ''}
          >
            <PaginationLink onClick={() => this.fetchFindings(url, pageIndex)}>
              {pageIndex + 1}
            </PaginationLink>
          </PaginationItem>,
        );
      }
    }
    if (rightPages > 1 && pageCount - 3 > currentPage) {
      pages.push(
        <PaginationItem key={'right' + '-0'} className="more-pages">
          ...
        </PaginationItem>,
      );
    }
    if (rightPages >= 1) {
      let url =
        '/release_notes/?search=' +
        this.state.company_search_data +
        '&limit=' +
        this.state.pageSize +
        '&offset=' +
        parseInt(this.state.pageSize * (pageCount - 1));
      pages.push(
        <PaginationItem
          key={'right' + '-1'}
          className={this.state.currentPage === pageCount - 1 ? 'active' : ''}
        >
          <PaginationLink
            onClick={() => this.fetchFindings(url, pageCount - 1)}
          >
            {pageCount}
          </PaginationLink>
        </PaginationItem>,
      );
    }
    // }
    return (
      <>
        {pages.map((item, index) => {
          return item;
        })}
      </>
    );
  }
  renderPagination() {
    let pageCount = Number(this.state.count / this.state.pageSize);
    if (pageCount > 1) {
      return (
        <Row>
          <Col sm="12" md="9" lg="10">
            <Pagination aria-label="Page navigation example">
              {this.renderPreviousUrl()}
              {this.renderPages()}
              {this.renderNextUrl()}
            </Pagination>
          </Col>
          <Col sm="12" md="3" lg="2">
            <Select
              className="custom-360-dropdown"
              value={{
                label: this.state.pageSize.toString(),
                value: this.state.pageSize.toString(),
              }}
              onChange={(e) => {
                this.setState({ pageSize: parseInt(e.value) });
                let self = this;
                setTimeout(function () {
                  self.fetchFindings();
                }, 100);
              }}
              styles={slimColourStyles}
              options={PAGE_SIZES}
            />
          </Col>
        </Row>
      );
    } else if (this.state.count > 25) {
      return (
        <Row>
          <Col sm="12" md="9" lg="10"></Col>
          <Col sm="12" md="3" lg="2">
            <Select
              className="custom-360-dropdown"
              value={{
                label: this.state.pageSize.toString(),
                value: this.state.pageSize.toString(),
              }}
              onChange={(e) => {
                this.setState({ pageSize: parseInt(e.value) });
                let self = this;
                setTimeout(function () {
                  self.fetchFindings();
                }, 100);
              }}
              styles={slimColourStyles}
              options={PAGE_SIZES}
            />
          </Col>
        </Row>
      );
    }
  }

  renderButton(data) {
    // if(data.report_status === 'COMPLETE'){
    return (
      <Row>
        {/* <Col sm="12">
                <Button color="primary" outline size="sm"
                    onClick={() => this.fetchFindingDetail.bind(this)(data.id)}>
                    <i className="fa fa-eye"></i>
                </Button>
                </Col> */}
        <Col sm="12">
          <Button
            color="primary"
            outline
            size="sm"
            onClick={() => this.fetchFindingNotes.bind(this)(data.id)}
          >
            <i className="tim-icons icon-pencil"></i>
          </Button>
        </Col>
        {/* <Col sm="12">
                <Button color="primary" outline size="sm"
                    onClick={() => this.fetchWatchers.bind(this)(data.id)}>
                    <i className="fa fa-users" aria-hidden="true"></i>
                </Button>
                </Col> */}
      </Row>
    );
  }
  renderURLData(data) {
    if (data.length > 40) {
      return (
        <a href={data} target="blank">
          {data.substr(0, 40)}...
        </a>
      );
    } else {
      return (
        <a href={data} target="blank">
          {data}
        </a>
      );
    }
  }
  renderReportList() {
    let reports = this.state.reports;
    return (
      <>
        {reports.map((data, idx) => {
          return (
            <>
              <tr key={idx}>
                <td>
                  Version
                  <strong style={{ marginLeft: '5px', marginRight: '5px' }}>
                    {data['version']}
                  </strong>
                  released on
                  <strong style={{ marginLeft: '5px', marginRight: '5px' }}>
                    {data['title']}
                  </strong>
                </td>
                <td></td>
                {this.approle === 'admin' ? (
                  <td className="text-right finding-buttons-div">
                    {this.renderButton.bind(this)(data)}
                  </td>
                ) : (
                  <td></td>
                )}
              </tr>
              <tr key={'solo-' + idx}>
                <td
                  colSpan="3"
                  dangerouslySetInnerHTML={{ __html: data['description'] }}
                ></td>
              </tr>
            </>
          );
        })}
      </>
    );
  }

  renderNotification() {
    // const [open, setOpen] = React.useState(true);
    return (
      <>
        <Collapse in={this.state.openModal === true}>
          <Alert
            severity={this.state.is_success === true ? 'success' : 'error'}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  this.setState({ openModal: false });
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <AlertTitle>{this.state.modalTitle}</AlertTitle>
            {this.state.modalDetail}
          </Alert>
        </Collapse>
      </>
    );
  }

  severityName(type) {}
  renderTr(key, label, type) {
    if (
      this.state.currentReport[key] &&
      this.state.currentReport[key] !== '' &&
      this.state.currentReport[key] !== null
    ) {
      return (
        <tr>
          <td>{label}</td>
          <td>
            {type === 'link' ? (
              <a href={this.state.currentReport[key]} target="blank">
                {this.state.currentReport[key]}
              </a>
            ) : (
              <>{this.state.currentReport[key]}</>
            )}
          </td>
        </tr>
      );
    }
  }
  renderDynamicRows(data) {}
  renderResultList(key, label, type) {
    if (
      this.state.currentReport[key] &&
      this.state.currentReport[key] !== '' &&
      this.state.currentReport[key] !== null
    ) {
      let currentReport = this.state.currentReport[key];
      let data = [];
      if (currentReport['list']) {
        data = currentReport['list'].map((item, index) => {
          if (type === 'accessPath' && item['Result']['accessPath']) {
            if (item['Result']['accessPath']['list']) {
              return item['Result']['accessPath']['list'].map(
                (_item, _index) => {
                  let preparedData = [];
                  let keys = Object.keys(_item);
                  for (let __index = 0; __index < keys.length; __index++) {
                    if (typeof _item[keys[__index]] === typeof {}) {
                      let _datum = _item[keys[__index]];
                      let _keys = Object.keys(_datum);
                      for (let __i = 0; __i < _keys.length; __i++) {
                        preparedData.push(
                          <tr>
                            <td>{keys[__index] + ' ' + _keys[__i]}</td>
                            <td>
                              {keys[__index].toLowerCase().indexOf('url') ===
                                0 ||
                              keys[__index].toLowerCase().indexOf('link') ? (
                                <a
                                  href={_item[keys[__index]][_keys[__i]]}
                                  target="new"
                                >
                                  {_item[keys[__index]][_keys[__i]]}
                                </a>
                              ) : (
                                <>{_item[keys[__index]][_keys[__i]]}</>
                              )}
                            </td>
                          </tr>,
                        );
                      }
                    } else if (typeof _item[keys[__index]] === typeof []) {
                    } else {
                      preparedData.push(
                        <tr>
                          <td>{keys[__index]}</td>
                          <td>
                            {keys[__index].toLowerCase().indexOf('url') === 0 ||
                            keys[__index].toLowerCase().indexOf('link') ? (
                              <a href={_item[keys[__index]]} target="new">
                                {_item[keys[__index]]}
                              </a>
                            ) : (
                              <>{_item[keys[__index]]}</>
                            )}
                          </td>
                        </tr>,
                      );
                    }
                  }
                  return (
                    <table className="table-striped">{preparedData}</table>
                  );
                },
              );
            }
          } else {
            if (item['Result']['payloads']['list']) {
              return item['Result']['payloads']['list'].map((_item, _index) => {
                if (
                  _item['PayloadInstance'] &&
                  _item['PayloadInstance']['request']
                ) {
                  return (
                    <table className="table-striped">
                      <tr>
                        <td>Header</td>
                        <td>
                          {_item['PayloadInstance']['request']['headers']}
                        </td>
                      </tr>
                      <tr>
                        <td>Link</td>
                        <td>
                          <a
                            href={_item['PayloadInstance']['request']['link']}
                            target="blank"
                          >
                            {_item['PayloadInstance']['request']['link']}
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>Method</td>
                        <td>{_item['PayloadInstance']['request']['method']}</td>
                      </tr>
                      <tr>
                        <td>Response</td>
                        <td>{_item['PayloadInstance']['response']}</td>
                      </tr>
                    </table>
                  );
                }
              });
            }
          }
        });
        if (data.length > 0)
          return (
            <tr>
              <td>{label}</td>
              <td>
                <table className="table-striped">{data}</table>
              </td>
            </tr>
          );
      }
    }
  }
  renderStrucList(key, label, innerKey) {
    if (
      this.state.currentReport[key] &&
      this.state.currentReport[key] !== '' &&
      this.state.currentReport[key] !== null
    ) {
      let currentReport = this.state.currentReport[key];
      let data = [];
      if (innerKey === undefined) {
        innerKey = 'OWASP';
      }
      // if (currentReport['list']) {
      data = currentReport.map((item, index) => {
        if (item[innerKey]) {
          let owasp = item[innerKey];
          let keys = Object.keys(owasp);
          let innerData = [];
          for (let index = 0; index < keys.length; index++) {
            innerData.push(
              <tr>
                <td>{keys[index]}</td>
                <td>
                  {keys[index].toLowerCase().indexOf('link') === 0 ||
                  keys[index].toLowerCase().indexOf('url') === 0 ? (
                    <a href={owasp[keys[index]]} target="new">
                      {owasp[keys[index]]}
                    </a>
                  ) : (
                    <>{owasp[keys[index]]}</>
                  )}
                </td>
              </tr>,
            );
          }
          return <table className="table-striped">{innerData}</table>;
        }
      });
      if (data.length > 0)
        return (
          <tr>
            <td>{label}</td>
            <td>
              <table className="table-striped">{data}</table>
            </td>
          </tr>
        );
      // }
    }
  }
  renderNestedTr(key, label) {
    if (
      this.state.currentReport[key] &&
      this.state.currentReport[key] !== '' &&
      this.state.currentReport[key] !== null
    ) {
      let currentReport = this.state.currentReport[key];
      let keys = Object.keys(currentReport);
      let data = [];
      for (let index = 0; index < keys.length; index++) {
        if (typeof currentReport[keys[index]] === typeof {}) {
          let datum = '';
          if (typeof currentReport[keys[index]] === typeof '') {
            datum = currentReport[keys[index]];
          } else if (typeof currentReport[keys[index]] === typeof {}) {
            let __keys = Object.keys(currentReport[keys[index]]);
            datum = [];
            for (let __index = 0; __index < __keys.length; __index++) {
              let __datum = '';
              let __parsableData = currentReport[keys[index]][__keys[__index]];
              if (typeof __parsableData === typeof {}) {
                __datum = [];
                let ___keys = Object.keys(__parsableData);
                for (let ___index = 0; ___index < ___keys.length; ___index++) {
                  __datum.push(
                    <tr>
                      <td>{___keys[___index].split('_').join(' ')}</td>
                      <td>
                        {___keys[___index].toLowerCase().indexOf('link') ===
                          0 ||
                        ___keys[___index].toLowerCase().indexOf('url') === 0 ? (
                          <a
                            href={__parsableData[___keys[___index]]}
                            target="new"
                          >
                            {__parsableData[___keys[___index]]}
                          </a>
                        ) : (
                          <>{__parsableData[___keys[___index]]}</>
                        )}
                      </td>
                    </tr>,
                  );
                }
              } else {
                __datum = __parsableData;
              }
              datum.push(
                <tr>
                  <td>{__keys[__index].split('_').join(' ')}</td>
                  <td>{__datum}</td>
                </tr>,
              );
            }
          }
          data.push(
            <tr>
              <td>{keys[index]}</td>
              <td>{datum}</td>
            </tr>,
          );
        } else if (typeof currentReport[keys[index]] === typeof []) {
          let innerData = currentReport[keys[index]];
          let innerRows = [];
          for (let index = 0; index < innerData.length; index++) {
            let innerKeys = Object.keys(innerData[index]);
            let _innerRow = [];
            for (let index = 0; index < innerKeys.length; index++) {
              _innerRow.push(
                <tr>
                  <td>{innerKeys[index].split('_').join(' ')}</td>
                  <td>
                    {innerKeys[index].toLowerCase().indexOf('link') === 0 ||
                    innerKeys[index].toLowerCase().indexOf('url') === 0 ? (
                      <a href={innerData[index][innerKeys[index]]} target="new">
                        {innerData[index][innerKeys[index]]}
                      </a>
                    ) : (
                      <>{innerData[index][innerKeys[index]]}</>
                    )}
                  </td>
                </tr>,
              );
            }
            innerRows.push(
              <table className="table-striped">{_innerRow}</table>,
            );
          }
          data.push(
            <tr>
              <td colSpan="2">
                <table className="table-striped">{innerRows}</table>
              </td>
            </tr>,
          );
        } else {
          data.push(
            <tr>
              <td>{keys[index].split('_').join(' ')}</td>
              <td>{currentReport[keys[index]]}</td>
            </tr>,
          );
        }
      }
      if (data.length > 0)
        return (
          <tr>
            <td>{label}</td>
            <td>
              <table className="table-striped">{data}</table>
            </td>
          </tr>
        );
    }
  }
  renderNestedArray(key, label) {
    if (
      this.state.currentReport[key] &&
      this.state.currentReport[key] !== '' &&
      this.state.currentReport[key] !== null
    ) {
      let data = [];
      if (key === 'vendor_reference_list' || key === 'cve_list') {
        data = this.state.currentReport[key].map((item, index) => {
          return (
            <div className="item-list">
              <a href={item.url} target="blank">
                {item.id}
              </a>
            </div>
          );
        });
      } else {
        data = this.state.currentReport[key].map((item, oindex) => {
          let innerTable = [],
            innerKeys = Object.keys(item);
          for (let index = 0; index < innerKeys.length; index++) {
            innerTable.push(
              <tr>
                <td>{innerKeys[index].split('_').join(' ')}</td>
                <td>{item[innerKeys[index]]}</td>
              </tr>,
            );
          }
          return <table className="table-striped">{innerTable}</table>;
        });
      }
      if (data.length > 0) {
        return (
          <tr>
            <td>{label}</td>
            <td>{data}</td>
          </tr>
        );
      }
    }
  }
  renderHostOptions() {
    let { source_type, current_host, hostapps } = this.state;
    if (source_type.value !== '') {
      return (
        <>
          <Label>Host</Label>
          <Select
            className="custom-360-dropdown"
            value={current_host}
            onChange={(e) => {
              this.setState(
                { current_host: e },
                // { endpoint: e.id}
              );
              let self = this;
              setTimeout(function () {
                self.fetchFindings();
              }, 100);
            }}
            styles={colourStyles}
            options={hostapps}
          />
        </>
      );
    }
  }
  renderCWE() {
    let cwe = this.state.currentReport.cwe,
      data = [];
    cwe.forEach((element) => {
      data.push(
        <a
          href={'https://cwe.mitre.org/data/definitions/' + element + '.html'}
          target="blank"
        >
          CWE-{element}
        </a>,
      );
    });
    return data;
  }
  // renderContentAsRawJs() {
  //     const contentState = this.state.editorState.getCurrentContent();
  //     const raw = convertToRaw(contentState);
  //     const markdownString = draftToMarkdown(raw);
  //     return markdownString;
  // }
  // renderNotesContent(){
  //     let notes = this.state.notes.results
  //     if(notes === undefined) notes = []
  //     let data = notes.map((item, oindex) => {
  //         return(<Row style={{marginBottom: '15px'}}>
  //             <Col md='12' className="spaced">
  //                 <i className='custom-icon-text spaced'>{item.initials}</i>
  //                 {item.name} added a note on {moment(item.created_at).format('lll')}
  //             </Col>
  //             <Col md='12' className="spaced" style={{paddingLeft: '58px'}}>
  //                 <ReactMarkdown
  //                     source={item.data}
  //                     escapeHtml={false}
  //                 />
  //             </Col>
  //         </Row>)
  //     })
  //     return(<Row>
  //         <Col md='12'>
  //             {data}
  //         </Col>
  //     </Row>)
  // }
  notesModal() {
    let { editorValue, current_note } = this.state;
    // If the user changes block type before entering any text, we can
    // either style the placeholder or hide it. Let's just hide it now.
    return (
      <Modal
        isOpen={this.state.notesmodal}
        toggle={this.toggleNotesModal.bind(this)}
        size="lg"
      >
        <ModalHeader toggle={this.toggleNotesModal.bind(this)}>
          Release Note
        </ModalHeader>
        <ModalBody>
          <CustomModalWrapper id="release-note-modal">
            <Row className="h-100">
              <Col xs="12" md="6">
                <FormGroup>
                  <label>Version </label>
                  <span style={{ color: 'red' }}>*</span>
                  <Input
                    name="version"
                    defaultValue={current_note.version}
                    onChange={(event) => {
                      current_note.version = event.target.value;
                      this.setState({ current_note: current_note });
                    }}
                    placeholder="Version"
                    type="text"
                    maxLength={50}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" md="6">
                <FormGroup>
                  <label>Date </label>
                  <span style={{ color: 'red' }}>*</span>
                  <Input
                    name="title"
                    defaultValue={current_note.title}
                    onChange={(event) => {
                      current_note.title = event.target.value;
                      this.setState({ current_note: current_note });
                    }}
                    placeholder="Date"
                    type="text"
                    maxLength={100}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" style={{ height: '100%' }}>
                <FormGroup style={{ height: '100%' }}>
                  <label>Description </label>
                  <span style={{ color: 'red' }}>*</span>
                  <ReactQuill
                    // ref={(el) => { this.reactQuillRef = el }}
                    theme={'snow'}
                    style={{ height: '100%' }}
                    modules={QModules}
                    formats={QFormats}
                    value={editorValue}
                    onChange={(value) => {
                      if (value) this.setState({ editorValue: value });
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
          </CustomModalWrapper>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={() => this.toggleNotesModal.bind(this)()}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={() => this.saveNote.bind(this)()}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
  render() {
    // let tagData = this.state.tagData;

    return (
      <>
        <div className="content main-panel">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col xl="12" md="12" sm="12" className="text-right">
                      <Row>
                        <Col md="9" sm="12" className="text-left">
                          <h4>
                            Release Notes
                            <label className="label btn">
                              {this.state.count}
                            </label>
                          </h4>
                        </Col>
                        <Col md="2" sm="12" className="text-left">
                          {/* <Label>Search</Label>
                                                        <Input type="text" list="data"
                                                            value={this.state.company_search_data}
                                                            placeholder="Search Release Notes"
                                                            onChange={(e) => {
                                                                this.setState({
                                                                    company_search_data: e.target.value,
                                                                })
                                                                let self = this;
                                                                setTimeout(function () {
                                                                    self.fetchFindings()
                                                                }, 60)
                                                            }}
                                                        /> */}
                        </Col>
                        <Col md="1" sm="12" className="text-right">
                          {this.approle === 'admin' && (
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() =>
                                this.fetchFindingNotes.bind(this)()
                              }
                            >
                              <i className="fa fa-plus"></i>
                              <span
                                style={{
                                  fontSize: '10px',
                                  fontWeight: 'normal',
                                  paddingTop: '2px',
                                }}
                              >
                                Create
                              </span>
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardHeader>
                {this.state.count == 0 && <NoRecordFound />}
                {this.state.count != 0 && (
                  <CardBody>
                    <Table className="tablesorter " responsive>
                      <tbody>{this.renderReportList.bind(this)()}</tbody>
                    </Table>
                  </CardBody>
                )}
                <CardFooter>{this.renderPagination.bind(this)()}</CardFooter>
              </Card>
            </Col>
          </Row>
        </div>
        {this.renderNotification()}
        {this.notesModal()}
        {this.renderLoader()}
      </>
    );
  }
}

export { ReleaseNoteList };
